import type { MonospaceFile } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { createFileHooks } from '~/rstore/utils/collections/files';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const FILE_DATETIME_FIELDS = ['createdAt', 'updatedAt'] as const;

export const File = RStoreSchema.withItemType<MonospaceFile>().defineCollection({
	name: 'MonospaceFile',
	computed: {
		$thumbnail: (item) => item,
	},
	fields: defineSystemDateTimeFields(FILE_DATETIME_FIELDS),
	meta: {
		defaultFields: ['id', 'fileName', 'fileSize', 'mediaType', 'title', 'description', 'tags', 'createdAt', 'updatedAt'],
		useWorkspaceSlug: true,
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(FILE_DATETIME_FIELDS),
	},
	hooks: createFileHooks('workspace'),
});
